import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";

const DeleteTableDialog = ({ openDialog, cancelDelete, confirmDelete }) => {
  return (
    <Dialog
      open={openDialog}
      onClose={cancelDelete}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.02)",
          boxShadow: "none", // Adjust the opacity as needed (0.3 is lighter)
        },
      }}
    >
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this table?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancelDelete} color="primary">
          Cancel
        </Button>
        <Button onClick={confirmDelete} color="secondary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTableDialog;
